const API_TOKEN = "API_TOKEN";
const ROLE = "ROLE";
const AGALIA_ID = "AGALIA_ID";

export { API_TOKEN, ROLE, AGALIA_ID };
